import { __spreadArray } from "tslib";
import * as DOMPurify from 'dompurify';
export var sanitizeHtml = function (html, allowedCustomTags, allowedCustomAttributes) {
    if (allowedCustomTags === void 0) { allowedCustomTags = []; }
    if (allowedCustomAttributes === void 0) { allowedCustomAttributes = []; }
    // until we have a better solution for SSR (isomorphic dompurify)
    if (typeof window === 'undefined' || !DOMPurify.isSupported)
        return '';
    // taken form https://github.com/apostrophecms/sanitize-html as we migrated from it to dompurify to be consistent
    var DEFAULT_ALLOWED_TAGS_FROM_SANITIZE_HTML = [
        'address', 'article', 'aside', 'footer', 'header', 'h1', 'h2', 'h3', 'h4',
        'h5', 'h6', 'hgroup', 'main', 'nav', 'section', 'blockquote', 'dd', 'div',
        'dl', 'dt', 'figcaption', 'figure', 'hr', 'li', 'main', 'ol', 'p', 'pre',
        'ul', 'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn',
        'em', 'i', 'kbd', 'mark', 'q', 'rb', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp',
        'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr', 'caption',
        'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'img', 'bold', 'span',
        'video', 'source'
    ];
    var DEFAULT_ALLOWED_TAGS = __spreadArray(__spreadArray([], DEFAULT_ALLOWED_TAGS_FROM_SANITIZE_HTML, true), [
        'img',
        'bold',
        'span'
    ], false);
    var ALLOWED_CUSTOM_TAGS = __spreadArray([], allowedCustomTags, true);
    var ALLOWED_CUSTOM_ATTRIBUTES = __spreadArray([], allowedCustomAttributes, true);
    var DEFAULT_ALLOWED_ATTRS = ['class', 'src', 'bold', 'img', 'span', 'href', 'target', 'width', 'height', 'type', 'controls', 'id', 'scrolling', 'allow', 'msallowfullscreen', 'frameborder'];
    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        if (node.tagName === 'IMG' || node.tagName === 'SOURCE') {
            var rawSrc = node.getAttribute('src') || '';
            if (rawSrc) {
                var processedSrc = rawSrc.replace('http://', 'https://');
                node.setAttribute('src', processedSrc);
            }
        }
        else if (node.tagName !== 'VIDEO' && node.tagName !== 'IFRAME') {
            node.removeAttribute('width');
            node.removeAttribute('height');
        }
    });
    var sanitizedHtml = DOMPurify.sanitize(html, {
        ALLOWED_TAGS: __spreadArray(__spreadArray([], DEFAULT_ALLOWED_TAGS, true), ALLOWED_CUSTOM_TAGS, true),
        ALLOWED_ATTR: __spreadArray(__spreadArray([], DEFAULT_ALLOWED_ATTRS, true), ALLOWED_CUSTOM_ATTRIBUTES, true)
    });
    DOMPurify.removeAllHooks();
    return sanitizedHtml;
};
//# sourceMappingURL=sanitizer.js.map